const Icon: React.FC<IconProps> = ({
  color = "black",
  width = "21px",
  height = "19px",
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 19" width={width} height={height}>
      <path xmlns="http://www.w3.org/2000/svg" d="M12.375 15.875H8.57812C7.96875 15.875 7.5 16.3906 7.5 17C7.5 17.6562 7.96875 18.125 8.57812 18.125H12.3281C12.9844 18.125 13.5 17.6562 13.5 17C13.5 16.3906 12.9844 15.875 12.375 15.875ZM19.875 0.875H1.07812C0.46875 0.875 0 1.39062 0 2C0 2.5625 0.46875 3.125 1.07812 3.125H19.875C20.4844 3.125 21 2.65625 21 2.04688C21 1.48438 20.4844 0.875 19.875 0.875ZM16.875 8.375H4.07812C3.46875 8.375 3 8.89062 3 9.5C3 10.1562 3.46875 10.625 4.07812 10.625H16.8281C17.4844 10.625 18 10.1562 18 9.5C18 8.89062 17.4844 8.375 16.875 8.375Z" fill={color}/>
    </svg>
  );
};

export default Icon;
